import { render } from "./SettlementAccount.m.vue?vue&type=template&id=73527340&scoped=true"
import script from "./SettlementAccount.m.vue?vue&type=script&lang=js"
export * from "./SettlementAccount.m.vue?vue&type=script&lang=js"

import "./SettlementAccount.m.vue?vue&type=style&index=0&id=73527340&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73527340"]])

export default __exports__